import {NinchatProperties} from '../../api/types'
import React from 'react'
import {describeFile} from 'api/action/describeFile'
import styles from './styles/ImageView.module.scss'
import {useAppDispatch} from '../../hooks'

interface ImageProps {
    file_id?: NinchatProperties.FileID;
    height?: number | null;
    src?: string | null;
    width?: number | null;
}

const ImageView: React.FC<ImageProps> = (props: ImageProps): React.ReactElement => {
    const {
        file_id,
        height,
        src,
        width,
    } = props

    const dispatch = useAppDispatch()

    const [loadingClass, setLoadingClass] = React.useState('')
    const [loadError, setLoadError] = React.useState(false)

    const onError = (): void => {
        if (file_id && !loadError) {
            setLoadError(true)
            setLoadingClass('')
            dispatch(describeFile({file_id}))
                .unwrap()
                .then(
                    null,
                    () => undefined,
                )
        }
    }

    const onLoad = (): void => {
        setLoadingClass('loaded')
        setLoadError(false)
    }

    return (
        <div className={`${styles.ImageView} ${styles[loadingClass]}`}>
            {!!src &&
                <img
                    onError={onError}
                    onLoad={onLoad}
                    src={src}
                    style={
                        height || width ?
                            {
                                height: height ? `${height}px` : 'auto',
                                width: width ? `${width}px` : 'auto',
                            } :
                            {
                                maxHeight: '100%',
                                objectFit: 'contain',
                                width: 'auto',
                            }
                    }
                />}
        </div>
    )
}

ImageView.defaultProps = {
    file_id: undefined, // eslint-disable-line no-undefined
    height: null,
    src: null,
    width: null,
}

export default ImageView
